import React, { useState } from 'react';
// import Followers from './followers/Followers';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import {
  getAllAgencyOrgList,
  getAllFacilityOrgList
} from 'nursd-dashboard/api/organizationTable';
import { useEffect } from 'react';
import { updateDetails } from 'nursd-dashboard/api/agencyTable';
import { socket } from 'nursd-dashboard/api/socket';
import { toast } from 'react-toastify';
import { Card, Col, Form, Row } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
// import paths from 'routes/paths';
// import { Link } from 'react-router-dom';
import AgencyTable from './table/AgencyTable';
import Update_Agency from './update_agency';
import { postFacilityNotification } from 'nursd-dashboard/api/facilityNotification';
import { sendNotification } from 'nursd-dashboard/api/webNotification';
import moment from 'moment';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';

const Agency = () => {
  const [options] = useState(['All', 'Active', 'DeActive']);

  // const [followers] = useState(people.slice(0, 24));
  const [followers, setFollowers] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [filterDrop, setFilterDrop] = useState(null);
  const [searchText, setSearchText] = useState('');
  // const [viewType, setViewType] = useState('table');
  const [show, setShow] = useState(false);
  const [data, setData] = useState(undefined);

  const { authToken, location, organization } = useAuth();

  const getAgency = async () => {
    setLoadingScreen(true);
    try {
      const cusList = await getAllAgencyOrgList(
        authToken,
        location,
        organization
      );

      const list = cusList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        let obj = {
          id: item.id,
          uniqueId: item.uniqueId,
          name: item?.additionalFields[0].agencyName,
          contact: item.firstName + ' ' + item.lastName,
          profileImage: item.profileImage,
          emailId: item.emailId,
          agencyLoginControl: item?.agencyLoginControl,
          licenseTypes: item?.additionalFields[0]?.licenseTypes,
          original: item
        };
        array.push(obj);
      }

      let arrayDownload = [];

      for (let i = 0; i < list?.length; i++) {
        const item = list[i];
        let obj = {
          // id: item.id,
          // uniqueId: item.uniqueId,
          // createdAt: item.createdAt,
          // updatedAt: item.updatedAt,
          emailId: item.emailId,
          firstName: item?.firstName,
          lastName: item?.lastName,
          // password: item?.password,
          phoneNumber: item?.phoneNumber
          // mobileId: item?.mobileId,
          // fullAddress: item?.fullAddress,
          // latitude: item?.latitude,
          // longitude: item?.longitude,
          // profileImage: item?.profileImage,
          // organization: item?.organization,
          // location_id: item?.location_id,
          // emailVerified: item?.emailVerified ? "Yes" : "No",
          // agencyVerified: item?.agencyVerified ? "Yes" : "No",
          // agencyLoginControl: item?.agencyLoginControl ? "Yes" : "No",
          // agencyAppAccessControl: item?.agencyAppAccessControl ? "Yes" : "No",
        };
        arrayDownload.push(obj);
      }

      if (
        list.length === array.length &&
        list.length === arrayDownload.length
      ) {
        setFollowers(array);
        setDownloadData(arrayDownload);
        setLoadingScreen(false);
      }
    } catch (error) {
      setFollowers([]);
      setDownloadData([]);
      setLoadingScreen(false);
    }
  };

  useEffect(() => {
    if (location !== '') {
      getAgency();
    }
  }, [authToken, location]);

  const filter = data => {
    return data?.filter(item =>
      item?.name?.toLowerCase().includes(searchText?.toLowerCase())
    );
  };

  //Update user function
  const updateUser = async (id, data, name, value) => {
    await updateDetails(authToken, id, data).then(() => {
      socket?.emit('activateDeactivate', {
        table: 'AgencyTable',
        id: id
      });
      if (value === 'Deactivate') {
        toast.error(`${name} has been ${value}d successfully.`, {
          theme: 'colored'
        });
      } else {
        toast.success(`${name} has been ${value}d successfully.`, {
          theme: 'colored'
        });
      }
      getAgency();
      getAllFacilityOrgList(authToken, location, organization)
        .then(async facilitiesData => {
          for (const facility of facilitiesData) {
            if (Number(facility?.id) !== Number(id))
              try {
                await postFacilityNotification(
                  authToken,
                  facility?.id,
                  '',
                  `Agency ${name} has been ${value}d`,
                  `Agency ${name} has been ${value}d by Admin.`,
                  'NotificationScreen',
                  {
                    id: ''
                  },
                  false,
                  false,
                  'green',
                  ''
                );
                socket?.emit('tableNotificationInsert', {
                  table: 'FacilityNotificationTable',
                  id: facility?.id
                });
                if (facility?.mobileId) {
                  sendNotification(authToken, {
                    expoPushToken: facility?.mobileId,
                    title: `Agency ${name} has been ${value}d`,
                    body: `Agency ${name} has been ${value}d by Admin.`,
                    data: { screen: 'NotificationScreen' }
                  });
                }
              } catch (error) {
                console.error('Error fetching facility detail:', error);
              }
          }
        })
        .catch(error => console.error('Fetching facility:', error));
    });
  };

  function convertToCSV(jsonData) {
    const separator = ',';
    const keys = Object.keys(jsonData[0]);
    const csvContent = [
      keys.join(separator),
      ...jsonData.map(item => {
        // Extract the 'FullAddress' and 'LicenseType' properties
        const { ...rest } = item;

        // Join the values of the other properties with the 'FullAddress' and 'LicenseType' values
        const values = keys.map(key => rest[key]);

        return values.join(separator);
      })
    ].join('\n');

    return csvContent;
  }

  const downloadCSVFile = data => {
    let current = moment().format('MM-DD-YYYY');
    // Create a Blob object for the CSV data
    const blob = new Blob([data], { type: 'text/csv' });

    // Create a temporary URL for the Blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.download = `${location}-Partner-AgencyList-${current}.csv`;

    // Trigger the download
    link.click();

    // Clean up the temporary URL
    URL.revokeObjectURL(url);
  };

  return (
    <>
      {!show ? (
        <Card>
          <Card.Header className="bg-body-tertiary">
            <Row className="mt-2 mb-3 align-items-center">
              <Col>
                <h5 className="mb-0 mx-1 text-secondary">
                  Partner Agency Records :{' '}
                  {
                    filter(followers)?.filter(e =>
                      filterDrop === null
                        ? e
                        : e?.agencyLoginControl === filterDrop
                    )?.length
                  }
                </h5>
              </Col>
              <Col sm={3}>
                <Form.Control
                  placeholder="Search by name..."
                  onChange={e => setSearchText(e.target.value)}
                  size="sm"
                />
              </Col>
              <Col className="d-md-block d-none" sm={2}>
                <Form.Select
                  onChange={e =>
                    setFilterDrop(
                      e.target.value === 'Active'
                        ? true
                        : e.target.value === 'DeActive'
                        ? false
                        : null
                    )
                  }
                  size="sm"
                  value={filterDrop}
                >
                  {options.map(option => (
                    <option key={option}>{option}</option>
                  ))}
                </Form.Select>
              </Col>
              <Col xs="auto" className="d-flex order-md-0">
                <Link to={paths.nursd_agency_upload}>
                  <IconButton
                    variant="success"
                    iconClassName="me-2"
                    icon="plus"
                    size="sm"
                  >
                    <span className="text-light ms-1">Upload CSV</span>
                  </IconButton>
                </Link>
                <Link to={paths.nursd_agency_form}>
                  <IconButton
                    variant="falcon-default"
                    size="sm"
                    icon="plus"
                    transform="shrink-3"
                    className="mx-2"
                  >
                    <span className="d-none text-dark d-sm-inline-block ms-1">
                      New
                    </span>
                  </IconButton>
                </Link>
                <IconButton
                  variant="falcon-default"
                  size="sm"
                  icon="external-link-alt"
                  transform="shrink-3"
                  onClick={() => downloadCSVFile(convertToCSV(downloadData))}
                >
                  <span className="d-none d-sm-inline-block ms-1">Export</span>
                </IconButton>
              </Col>
            </Row>
          </Card.Header>
          {location === '' ? (
            <div className="m-3">
              <p>Select Location Id</p>
            </div>
          ) : loadingScreen ? (
            <div className="m-3">
              <p>Loading...</p>
            </div>
          ) : followers?.length === 0 ? (
            <div className="m-3">
              <p>{location} - No Data Available</p>
            </div>
          ) : (
            <Card.Body className="bg-body-tertiary px-1 pb-1 pt-0 fs-10">
              {/* {viewType === 'card' ? (
                <Followers
                  data={followers}
                  updateUser={updateUser}
                  setShow={setShow}
                  setData={setData}
                />
              ) : ( */}
              <AgencyTable
                data={filter(followers)?.filter(e =>
                  filterDrop === null ? e : e?.agencyLoginControl === filterDrop
                )}
                updateUser={updateUser}
                setShow={setShow}
                setData={setData}
              />
              {/* )} */}
            </Card.Body>
          )}
        </Card>
      ) : (
        <Card>
          <Card.Header className="bg-body-tertiary">
            <h5>Update Agency</h5>
          </Card.Header>
          <Card.Body className="bg-body-tertiary p-3">
            <Update_Agency
              data={data}
              authToken={authToken}
              getAgency={getAgency}
              setShow={setShow}
            />
          </Card.Body>
        </Card>
      )}
    </>
  );
};

Agency.propTypes = {};

export default Agency;
